import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';

import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import {
	getHydrationErrorWithRoute,
	getHydrationFailureOperationalEvent,
} from '@confluence/ssr-utilities/entry-points/matchHydrationError.ts';
import { expVal } from '@confluence/feature-experiments';

export function reportHydrationError(
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	metricKey: string,
) {
	if (!(window?.__SSR_RENDERED__ && Boolean(window.__HYDRATION_FAILED__))) {
		return;
	}

	const { error: errorWithRoute, route } = getHydrationErrorWithRoute(window.location.toString());
	const attribution = Boolean(window.__SSR_REACT_STREAMING__) ? 'streaming-hydration' : 'hydration';

	if (expVal('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) {
		createAnalyticsEvent(
			getHydrationFailureOperationalEvent({
				source: `PageLoadEnd - ${metricKey}`,
				route,
				errorWithRoute,
				isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__),
			}),
		).fire();
	} else {
		getMonitoringClient().submitError(errorWithRoute, {
			attribution,
		});
	}
}
